import { useMutation, useQueryClient } from "@tanstack/react-query";
import { z } from "zod/v4";

import { getGaragesQueryOptions } from "./get-garages";

import { api } from "@/lib/api-client";

import type { MutationConfig } from "@/lib/react-query";
import type { Garage } from "@/types/garage";

export const createGarageInputSchema = z.object({
  name: z.string().nonempty(),
});

export type CreateGarageInput = z.infer<typeof createGarageInputSchema>;

export const createGarage = async ({ data }: { data: CreateGarageInput }): Promise<Garage> => {
  return (await api.post("/carburate/garages/", data)) as Garage;
};

type UseCreateGarageOptions = {
  mutationConfig?: MutationConfig<typeof createGarage>;
};

export const useCreateGarage = ({ mutationConfig }: UseCreateGarageOptions = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: getGaragesQueryOptions().queryKey });
      queryClient.invalidateQueries({ queryKey: ["garage-cars"], exact: false });
      onSuccess?.(...args);
    },
    ...restConfig,
    mutationFn: createGarage,
  });
};
